const servicesConfig = {
    // estos servicios son cacheados, los que no están indicados NO SE CACHEAN.

    b2bNew_dbo_HTML_MarcasBusqueda: {
        serviceName: 'b2bNew.dbo.HTML_MarcasBusqueda',
        cacheable: true,
    },
    b2bNew_dbo_HTML_PedidosEstados: {
        serviceName: 'b2bNew.dbo.HTML_PedidosEstados',
        cacheable: true,
    },
    b2bNew_dbo_HTML_FormasPago: {
        serviceName: 'b2bNew.dbo.HTML_FormasPago',
        cacheable: true,
    },
    b2bNew_dbo_HTML_TipoVehiculosBusqueda: {
        serviceName: 'b2bNew.dbo.HTML_TipoVehiculosBusqueda',
        cacheable: true,
    },

    b2bNew_dbo_HTML_Contacto: {
        serviceName: 'b2bNew.dbo.HTML_Contacto',
        cacheable: true,
    },
    b2bNew_dbo_HTML_MedidasMasBuscadas: {
        serviceName: 'b2bNew.dbo.HTML_MedidasMasBuscadas',
        cacheable: true,
    },
    b2bNew_dbo_HTML_OpcionesCaracteristicas: {
        serviceName: 'b2bNew.dbo.HTML_OpcionesCaracteristicas',
        cacheable: true,
    },
    b2bNew_dbo_HTML_ArticulosBusquedaMedida: {
        serviceName: 'b2bNew.dbo.HTML_ArticulosBusquedaMedida',
        cacheable: true,
    },
    b2bNew_dbo_HTML_ArticulosBusquedaOrden: {
        serviceName: 'b2bNew.dbo.HTML_ArticulosBusquedaOrden',
        cacheable: true,
    },
    b2bNew_dbo_HTML_PortadaLeer: {
        serviceName: 'b2bNew.dbo.HTML_PortadaLeer',
        cacheable: true,
    },
    b2bNew_dbo_HTML_AlmacenesAgenciasHoras: {
        serviceName: 'b2bNew.dbo.HTML_AlmacenesAgenciasHoras',
        cacheable: true,
    },
    b2bNew_dbo_HTML_PromosPortada: {
        serviceName: 'b2bNew.dbo.HTML_PromosPortada',
        cacheable: true,
    },
};

export default servicesConfig;
